import { SkeletonRectangularImageLoading, SkeletonTextLoading } from '.';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var SkeletonElementLoading = function SkeletonElementLoading(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      loading = _ref.loading;

  if (loading) {
    if (type === 'text') return /*#__PURE__*/_jsx(SkeletonTextLoading, {
      width: "medium"
    });
    if (type === 'gallery') return /*#__PURE__*/_jsx(SkeletonRectangularImageLoading, {});
  } // eslint-disable-next-line react/jsx-no-useless-fragment


  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};